import { Icon } from '@chakra-ui/react';

export const CustomArrowIcon = (props) => (
  <Icon viewBox="0 0 492 492" {...props}>
    <path
      fill="currentColor"
      d="
        M 297.89,396.39
        L 279.63,394.46
        L 263.78,380.53
        L 259.93,370.92
        L 259.45,323.36
        L 54.77,323.36
        L 42.28,317.59
        L 34.11,309.42
        L 29.31,297.89
        L 29.31,192.19
        L 35.07,179.70
        L 44.20,171.53
        L 54.77,167.68
        L 259.45,167.68
        L 259.93,119.16
        L 265.70,106.66
        L 274.83,98.50
        L 285.40,94.65
        L 297.89,94.65
        L 310.38,100.42
        L 446.36,223.90
        L 452.12,232.55
        L 455.00,246.96
        L 449.24,264.26
        L 437.23,276.27
        L 312.30,389.66
        L 297.89,396.39
        Z
      "
    />
  </Icon>
);
